// ============================================================================
// ARABIC TRANSLATIONS - BIBLE VERSES
// ============================================================================
// آيات الكتاب المقدس بالعربية مع أرقام سترونج (فان دايك)

export const bibleVersesAr = [
  {
    reference: "فيلبي 4: 13",
    text: "أَسْتَطِيعُ كُلَّ شَيْءٍ فِي الْمَسِيحِ الَّذِي يُقَوِّينِي",
    version: "فان دايك",
    theme: "القوة",
    strongNumbers: {
      "أَسْتَطِيعُ": "G2480", // ἰσχύω (ischyo) = قادر
      "يُقَوِّينِي": "G1743" // ἐνδυναμόω (endynamoo) = يقوي
    },
    context: "بولس يتحدث عن القوة التي نتلقاها في المسيح في جميع الظروف"
  },
  {
    reference: "مزمور 23: 1",
    text: "الرَّبُّ رَاعِيَّ فَلاَ يُعْوِزُنِي شَيْءٌ",
    version: "فان دايك",
    theme: "الثقة",
    strongNumbers: {
      "رَاعِيَّ": "H7462", // רָעָה (ra'ah) = راعي
      "يُعْوِزُنِي": "H2637" // חָסֵר (chaser) = ينقص
    },
    context: "داود يعبر عن ثقته في عناية الله بنا"
  },
  {
    reference: "يوحنا 3: 16",
    text: "لأَنَّهُ هكَذَا أَحَبَّ اللهُ الْعَالَمَ حَتَّى بَذَلَ ابْنَهُ الْوَحِيدَ، لِكَيْ لاَ يَهْلِكَ كُلُّ مَنْ يُؤْمِنُ بِهِ، بَلْ تَكُونُ لَهُ الْحَيَاةُ الأَبَدِيَّةُ",
    version: "فان دايك",
    theme: "المحبة",
    strongNumbers: {
      "أَحَبَّ": "G25", // ἀγαπάω (agapao) = يحب بلا شرط
      "بَذَلَ": "G1325", // δίδωμι (didomi) = يعطي
      "الأَبَدِيَّةُ": "G166" // αἰώνιος (aionios) = أبدي
    },
    context: "يسوع يكشف عن محبة الله اللامحدودة لنا"
  },
  {
    reference: "رومية 8: 28",
    text: "وَنَحْنُ نَعْلَمُ أَنَّ كُلَّ الأَشْيَاءِ تَعْمَلُ مَعًا لِلْخَيْرِ لِلَّذِينَ يُحِبُّونَ اللهَ، الَّذِينَ هُمْ مَدْعُوُّونَ حَسَبَ قَصْدِهِ",
    version: "فان دايك",
    theme: "العناية",
    strongNumbers: {
      "تَعْمَلُ مَعًا": "G4903", // συνεργέω (synergeo) = تعمل معاً
      "لِلْخَيْرِ": "G18" // ἀγαθός (agathos) = الخير
    },
    context: "بولس يؤكد عناية الله السيادية وقصده"
  },
  {
    reference: "أمثال 3: 5-6",
    text: "تَوَكَّلْ عَلَى الرَّبِّ بِكُلِّ قَلْبِكَ، وَعَلَى فَهْمِكَ لاَ تَعْتَمِدْ. فِي كُلِّ طُرُقِكَ اعْرِفْهُ، وَهُوَ يُقَوِّمُ سُبُلَكَ",
    version: "فان دايك",
    theme: "الحكمة",
    strongNumbers: {
      "تَوَكَّلْ": "H982", // בָּטַח (batach) = يثق
      "فَهْمِكَ": "H998", // בִּינָה (binah) = فهم
      "يُقَوِّمُ": "H3474" // יָשַׁר (yashar) = يجعل مستقيماً
    },
    context: "سليمان يحثنا على الثقة بالله أكثر من حكمتنا الخاصة"
  },
  {
    reference: "إشعياء 40: 31",
    text: "وَأَمَّا مُنْتَظِرُو الرَّبِّ فَيُجَدِّدُونَ قُوَّةً. يَرْفَعُونَ أَجْنِحَةً كَالنُّسُورِ. يَرْكُضُونَ وَلاَ يَتْعَبُونَ. يَمْشُونَ وَلاَ يُعْيُونَ",
    version: "فان دايك",
    theme: "التجديد",
    strongNumbers: {
      "مُنْتَظِرُو": "H6960", // קָוָה (qavah) = ينتظر، يرجو
      "يُجَدِّدُونَ": "H2498", // חָלַף (chalaph) = يجدد
      "قُوَّةً": "H3581" // כֹּחַ (koach) = قوة
    },
    context: "إشعياء يعد بالتجديد الروحي لمن ينتظرون الرب"
  },
  {
    reference: "متى 11: 28",
    text: "تَعَالَوْا إِلَيَّ يَا جَمِيعَ الْمُتْعَبِينَ وَالثَّقِيلِي الأَحْمَالِ، وَأَنَا أُرِيحُكُمْ",
    version: "فان دايك",
    theme: "الراحة",
    strongNumbers: {
      "الْمُتْعَبِينَ": "G2872", // κοπιάω (kopiao) = متعب
      "الثَّقِيلِي الأَحْمَالِ": "G5412", // φορτίζω (phortizo) = محمل
      "أُرِيحُكُمْ": "G373" // ἀναπαύω (anapauo) = أريح
    },
    context: "يسوع يوجه دعوة رحيمة لكل المتعبين"
  }
];

export default bibleVersesAr;
